import { render, staticRenderFns } from "./H2.vue?vue&type=template&id=ccfbc1e4&scoped=true"
import script from "./H2.vue?vue&type=script&lang=js"
export * from "./H2.vue?vue&type=script&lang=js"
import style0 from "./H2.vue?vue&type=style&index=0&id=ccfbc1e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfbc1e4",
  null
  
)

export default component.exports